/* eslint-disable import/prefer-default-export */
export function hasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}
